import type { TourKey } from '@osteopro/shared';

/**
 * Les quatre visites guidées. Une cible est un attribut `data-tour` posé sur un élément existant de
 * l'écran ; un repère dont la cible est absente (droit manquant, variante mobile) est sauté. Le
 * titre et le texte se lisent dans `onboarding:tour.{visite}.{repère}`.
 */
export interface TourStepDefinition {
  target: string;
  key: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export const TOURS: Readonly<Record<TourKey, readonly TourStepDefinition[]>> = {
  agenda: [
    { target: 'agenda-new-appointment', key: 'new_appointment' },
    { target: 'agenda-navigation', key: 'navigation' },
    { target: 'agenda-views', key: 'views' },
    { target: 'agenda-schedule', key: 'schedule' },
    { target: 'agenda-settings', key: 'settings' },
  ],
  patient: [
    { target: 'patient-identity', key: 'identity' },
    { target: 'patient-tabs', key: 'tabs' },
    { target: 'patient-edit', key: 'edit' },
    { target: 'patient-actions', key: 'actions', side: 'left' },
    { target: 'patient-timeline', key: 'timeline', side: 'left' },
  ],
  consultation: [
    { target: 'consultation-sections', key: 'sections', side: 'right' },
    { target: 'consultation-autosave', key: 'autosave', side: 'right' },
    { target: 'consultation-progress', key: 'progress' },
    { target: 'consultation-next', key: 'next', side: 'top' },
  ],
  invoice: [
    { target: 'invoice-tabs', key: 'tabs' },
    { target: 'invoice-new', key: 'new' },
    { target: 'invoice-filters', key: 'filters' },
    { target: 'invoice-unpaid', key: 'unpaid' },
  ],
};
